export default __webpack_public_path__ + "static/about2-f87d99ef81a18398c38ff72f01fee1b5.jpeg";